import { TaskChecklist } from 'aos-services/src/dataaccess/tasks/types/TaskDto'
import { Box, ChecklistIcon, ChecklistItemIcon, Icon, Link, Text } from 'aos-ui-universal'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

export const TaskTemplateChecklists = ({ checklists = [] }: { checklists: TaskChecklist[] }) => {
    const { t } = useTranslation()
    const [expanded, setExpanded] = useState<number[]>([])

    useEffect(() => {
        queueMicrotask(() => {
            setExpanded(checklists.map(({ id }) => id))
        })
    }, [checklists])

    const toggleExpanded = useCallback(
        (id: number) =>
            setExpanded(state =>
                state.includes(id) ? state.filter(item => item !== id) : [...state, id],
            ),
        [],
    )
    return (
        <Box>
            <Box className='flex-row gap-x-2 items-center'>
                <Icon size={24} as={ChecklistIcon} className='text-content-default' />
                <Text weight='light' size='H1' tone='default' className='align-middle'>
                    {t('checklist-manager.templates.item-section-title', { ns: 'checklist' })}
                </Text>
            </Box>
            <Box className='flex-col gap-y-4 py-4'>
                {checklists.map(checklist => {
                    const isOpen = expanded.includes(checklist.id)
                    return (
                        <Box key={checklist.id} className='flex-col gap-y-2'>
                            <Box className='flex-col gap-y-1'>
                                <Text tone='default' size='P3'>
                                    {checklist.name}
                                </Text>
                                {checklist.items.length > 0 && (
                                    <Box className='flex-col gap-y-1'>
                                        <Link
                                            size='caption'
                                            onPress={() => toggleExpanded(checklist.id)}
                                        >
                                            {isOpen
                                                ? t('status-dashboard.show-less', {
                                                      ns: 'dashboard',
                                                  })
                                                : t('status-dashboard.show-more', {
                                                      ns: 'dashboard',
                                                  })}
                                        </Link>
                                        {isOpen && (
                                            <Box className='flex-col gap-y-2'>
                                                {checklist.items.map(item => (
                                                    <Box
                                                        key={item.id}
                                                        className='flex-row gap-x-2 items-center'
                                                    >
                                                        <Icon
                                                            size={16}
                                                            as={ChecklistItemIcon}
                                                            className='text-content-muted'
                                                        />
                                                        <Text size='P3' tone='muted'>
                                                            {item.content}
                                                        </Text>
                                                    </Box>
                                                ))}
                                            </Box>
                                        )}
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    )
                })}
            </Box>
        </Box>
    )
}
